import { Component, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ScrollHandlingEventsEnum } from '@types-custom/models/ui/scroll-model';
import { ISpeedometerModel } from '@types-custom/models/ui/speedometer-model';
import * as am4core from '@amcharts/amcharts4/core';
import { BehaviorSubject } from 'rxjs';
import { ICardTrafficConcordanceModel } from '@types-custom/models/ui/card-traffic-concordance-model';
import {
  adjustConcordanceRotation,
  adjustSpeedometerRotation,
} from '@ui-core/utils/functions/get-indicator-rotation';
import { MapboxDataService } from '@sdk/services/map-box-data/mapbox-data.service';
import { GeometryTypeEnum, MarkerModelBase } from '@types-custom/models/business/marker.model';

@Component({
  selector: 'panel-traffic-concordance',
  templateUrl: './panel-traffic-concordance.component.html',
  styleUrls: ['./panel-traffic-concordance.component.scss'],
})
export class PanelTrafficConcordanceComponent implements OnInit {
  Icon = Icon;
  cards: ICardTrafficConcordanceModel[] = [];
  avSpeedIndicator = 0;
  avFlowIndicator = 0;
  listConcordance: Array<any> = [];
  panelActionsDispatcher!: BehaviorSubject<
    ScrollHandlingEventsEnum | undefined
  >;
  linesDispatcher: BehaviorSubject<any>;

  cardList: ICardTrafficConcordanceModel[] = [];

  layer = 'TrafficConcordance';

  private typeVectorNameMap: { [key: number]: string } = {
    1: 'Genérica',
    2: 'Vías 30',
  };

  //avgSpeedValue: 0;
  avgSpeedProps: ISpeedometerModel = {
    chartType: 4,
    divId: 'avgSpeed',
    descriptionLabel: 'Velocidad promedio',
    unitLabel: 'KM/H',
    labelsClass: 'gap-row-10-px',
    value: 0,
  };

  avgConcordanceProps: ISpeedometerModel = {
    chartType: 5,
    divId: 'avgConcordance',
    descriptionLabel: 'Concordancia',
    unitLabel: '%',
    labelsClass: 'gap-row-10-px',
    value: 0,
  };

  typeOptions: Array<any> = [
    {
      value: 1,
      text: 'Genéricas'
    },
    {
      value: 2,
      text: 'Vías 30'
    }
  ];

  defaultOption = 1;

  constructor(
    private mapboxDataService: MapboxDataService
  ) { }

  ngOnInit(): void {
    this.setIndicators(this.defaultOption);
    this.setGraphic(this.defaultOption);
  }

  optionTypeSelected(optionType: any) {
    this.defaultOption = optionType.value;
    this.setIndicators(this.defaultOption);
    this.setGraphic(this.defaultOption);
  }

  setIndicators(optionType: number) {
    let sumspeedAvg = 0;
    let totDistance = 0;
    let QtysumconcordanceAvg = 0;
    let sumconcordanceAvg = 0;

    const vetorName = this.typeVectorNameMap[optionType];

    const cards: ICardTrafficConcordanceModel[] = this.cards.filter(item => item.typeVector === vetorName);
    this.cardList = cards;

    cards.map((cards: ICardTrafficConcordanceModel) => {
      cards.speed = (+cards.speed).toFixed(2);
      if (!isNaN(+cards.speed)) {
        sumspeedAvg = sumspeedAvg + +cards.speed * (+cards.distance / 1000);
        if (+cards.speed > 0) {
          totDistance = totDistance + +cards.distance / 1000;
        }
      }
    });

    cards.map((cards: ICardTrafficConcordanceModel) => {
      if (!isNaN(+cards.concordance)) {
        QtysumconcordanceAvg += 1;
        const concordance = Math.round(+cards.concordance);
        sumconcordanceAvg = sumconcordanceAvg + concordance;
      }
    });

    this.avgSpeedProps.value = Math.round(sumspeedAvg / totDistance);
    this.avgConcordanceProps.value = Math.round(
      sumconcordanceAvg / QtysumconcordanceAvg
    );

    this.avgSpeedProps.handClockRotation = adjustSpeedometerRotation(
      this.avgSpeedProps.value
    );

    this.avgConcordanceProps.handClockRotation = adjustConcordanceRotation(
      this.avgConcordanceProps.value
    );
  }

  setGraphic(optionType: number) {
    const colorRange = [
      { min: Number.MIN_SAFE_INTEGER, max: -51, color: am4core.color('#FF4545') },
      { min: -50, max: -25, color: am4core.color('#FF6F6F') },
      { min: -24, max: -11, color: am4core.color('#FFBBBB') },
      { min: -10, max: 10, color: am4core.color('#5C9BFB') },
      { min: 11, max: 25, color: am4core.color('#D6FFD6') },
      { min: 26, max: 50, color: am4core.color('#7FF57D') },
      {
        min: 51,
        max: Number.MAX_SAFE_INTEGER,
        color: am4core.color('#2AC527'),
      },
    ];
    const lookup = {} as any;
    this.listConcordance = [];

    const vetorName = this.typeVectorNameMap[optionType];

    const cards: ICardTrafficConcordanceModel[] = this.cards.filter(item => item.typeVector === vetorName);

    cards.forEach((card) => {
      const concordanceOpt = Math.round(+card.concordance);
      const concordance =
        Math.floor(
          +(concordanceOpt > 100 ? 100 - concordanceOpt : concordanceOpt) / 10
        ) * 10;

      const colorObject = colorRange.find((range) => {
        return concordance >= range.min && concordance <= range.max;
      });

      const color = colorObject ? colorObject.color : am4core.color('#FC0606');

      if (concordance in lookup) {
        lookup[concordance].qty++;
      } else {
        lookup[concordance] = {
          id: concordance,
          color,
          label: concordance == 0 ? concordance : `${concordance}%`,
          qty: 1,
        };
        this.listConcordance.push(lookup[concordance]);
      }
    });
  }
}
